import { TileConfig } from "./SeverityTiles/SeverityTiles";

export const SEVERITY_MAP: Record<string, string> = {
  CRITICAL: 'Critical',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  INFORMATION: 'Information',
  All: 'Active Monitor',
};

export const TILE_LABELS: Record<string, string> = {
  CRITICAL: 'Critical Alerts',
  HIGH: 'High Alerts',
  MEDIUM: 'Medium Alerts',
  LOW: 'Low Alerts',
  INFORMATION: 'Information Alerts',
  All: 'Active Monitor',
};


export const ITSM_TILES_CONFIG: TileConfig[] = [
  { key: 'Incidents', label: 'Incidents', summaryKey: 'incidents' },
  { key: 'Service Requests', label: 'Service Requests', summaryKey: 'service' },  
  // { key: 'ServiceRequests', label: 'Service Requests', summaryKey: 'serviceRequests' },
  { key: 'Problem Tickets', label: 'Problem Tickets', summaryKey: 'problemTickets' },
  { key: 'Change Requests', label: 'Change Requests', summaryKey: 'change' },   
];

export const INCIDENTS_TILES_CONFIG: TileConfig[] = [
  { key: 'P3', label: 'P3', summaryKey: 'p3' },
  { key: 'P4', label: 'P4', summaryKey: 'p4' },
  { key: 'P5', label: 'P5', summaryKey: 'p5' },
  { key: 'Closed Incidents', label: 'Closed Incidents', summaryKey: 'closed' },
  { key: 'SLA Response Miss', label: 'SLA Response Miss', summaryKey: 'slaResponseMissed' },
  { key: 'SLA Resolution Miss', label: 'SLA Resolution Miss', summaryKey: 'slaResolutionMissed' },
];

export const CR_TILES_CONFIG: TileConfig[] = [
  { key: 'Emergency', label: 'Emergency', summaryKey: 'type' },
  { key: 'In Progress', label: 'In Progress', summaryKey: 'progress' },
  { key: 'Closed', label: 'Closed', summaryKey: 'close' },
  { key: 'Not Closed', label: 'Not Closed', summaryKey: 'notClose' },
  { key: 'Successful', label: 'Successful', summaryKey: 'successful' },
  { key: 'Unsuccessful', label: 'Unsuccessful', summaryKey: 'unsuccessful' },
  { key: 'SLA Met', label: 'SLA Met', summaryKey: 'metSla' },
  { key: 'SLA Missed', label: 'SLA Missed', summaryKey: 'slaMiss' }
];

export const SR_TILES_CONFIG: TileConfig[] = [
  { key: 'Open', label: 'Open', summaryKey: 'open' },
  { key: 'In Progress', label: 'In Progress', summaryKey: 'wip' },
  { key: 'Pending', label: 'Pending', summaryKey: 'pa' },
  { key: 'Closed Complete', label: 'Closed Complete', summaryKey: 'cc' },
  { key: 'Closed Incomplete', label: 'Closed Incomplete', summaryKey: 'ci' },
  // { key: 'AutomationCandidates', label: 'Automation Candidates', summaryKey: 'automationCandidates' }
];

export const PT_TILES_CONFIG: TileConfig[] = [
  { key: 'Open', label: 'Open', summaryKey: 'open' },
  { key: 'Known Errors', label: 'Known Errors', summaryKey: 'knowErrors' },
  { key: 'Reactive', label: 'Reactive', summaryKey: 'reactive' },
  { key: 'Made SLA', label: 'Made SLA', summaryKey: 'madeSla' },
  { key: 'RCA', label: 'RCA', summaryKey: 'rca' },
];

export const SUB_TILES_BY_PARENT: Record<string, TileConfig[]> = {
  Incidents: INCIDENTS_TILES_CONFIG,
  ['Change Requests']: CR_TILES_CONFIG,
  ['Service Requests']: SR_TILES_CONFIG,
  ['Problem Tickets']: PT_TILES_CONFIG,
  Alerts: [],
};

export const ALL_TILE_CONFIGS = [
  ...ITSM_TILES_CONFIG,
  ...INCIDENTS_TILES_CONFIG,
  ...CR_TILES_CONFIG,
  ...SR_TILES_CONFIG,
  ...PT_TILES_CONFIG,
];

export const LABELS: Record<string, string> = {
  Incidents: "Incidents",
  ['Change Requests']: "Change Requests",
  ['Service Requests']: "Service Requests",
  ['Problem Tickets']: "Problem Tickets",
  Alerts: "Alerts",
};